(function(){
  'use strict';
  var templateClass='template__page--kodak-technology-vsl';
  function isTechnologyPage(){return document.body&&document.body.classList.contains(templateClass);}
  function initScrollButtons(scope){
    scope.querySelectorAll('[data-kdkt-scroll-target]').forEach(function(button){
      if(button.dataset.kdktScrollReady) return;
      button.dataset.kdktScrollReady='true';
      button.addEventListener('click',function(){
        var targetId=button.getAttribute('data-kdkt-scroll-target');
        var target=document.getElementById(targetId);
        if(!target&&targetId==='kdkt-offer') target=document.querySelector('.'+templateClass+' [data-kdkt-offer], .'+templateClass+' .kodak-ads-pricing');
        if(target) target.scrollIntoView({behavior:'smooth',block:'start'});
      });
    });
  }
  function initCreators(root){
    if(!root || root.dataset.kdktReady) return;
    root.dataset.kdktReady='true';
    var player=root.querySelector('[data-kdkt-player]');
    var source=root.querySelector('[data-kdkt-player-source]');
    var caption=root.querySelector('[data-kdkt-caption]');
    root.querySelectorAll('[data-kdkt-thumbnail]').forEach(function(image){
      image.addEventListener('error',function(){
        var fallback=image.getAttribute('data-video-fallback');
        if(!fallback || !image.parentNode) return;
        var still=document.createElement('video');
        still.className='kdkt-clip__still';
        still.muted=true;
        still.playsInline=true;
        still.preload='metadata';
        still.setAttribute('aria-label',image.alt||'Video thumbnail');
        still.src=fallback;
        image.parentNode.replaceChild(still,image);
      },{once:true});
    });
    root.querySelectorAll('[data-kdkt-clip]').forEach(function(button){
      button.addEventListener('click',function(){
        root.querySelectorAll('[data-kdkt-clip]').forEach(function(item){item.setAttribute('aria-pressed','false');});
        button.setAttribute('aria-pressed','true');
        if(source && player){
          player.pause();
          source.src=button.getAttribute('data-video')+'#t=0.1';
          var poster=button.getAttribute('data-poster');
          if(poster) player.setAttribute('poster',poster); else player.removeAttribute('poster');
          player.load();
        }
        if(caption) caption.textContent=button.getAttribute('data-caption')||'';
      });
    });
  }
  function initProduct(root){
    if(!root || root.dataset.kdktReady) return;
    root.dataset.kdktReady='true';
    var select=root.querySelector('[data-kdkt-variant-select]');
    var price=root.querySelector('[data-kdkt-price]');
    var button=root.querySelector('[data-kdkt-add]');
    var jsonNode=root.querySelector('[data-kdkt-variants]');
    if(!select || !jsonNode) return;
    var variants=[];
    try{variants=JSON.parse(jsonNode.textContent);}catch(e){return;}
    function money(cents){
      try{return new Intl.NumberFormat(undefined,{style:'currency',currency:(window.shop&&window.shop.shopCurrency)||'USD'}).format(cents/100);}
      catch(e){return '$'+(cents/100).toFixed(2);}
    }
    function update(){
      var variant=variants.find(function(item){return String(item.id)===String(select.value);});
      if(!variant) return;
      if(price) price.textContent=money(variant.price);
      if(button){button.disabled=!variant.available;button.textContent=variant.available?(button.getAttribute('data-label')||'Add to cart'):'Sold out';}
    }
    select.addEventListener('change',update);update();
  }
  function initSticky(root){
    if(!root || root.dataset.kdktReady || !('IntersectionObserver' in window)) return;
    root.dataset.kdktReady='true';
    var sticky=root;
    var hero=document.querySelector('[data-kdkt-hero]');
    var offer=document.querySelector('.'+templateClass+' [data-kdkt-offer], .'+templateClass+' .kodak-ads-pricing');
    var footer=document.querySelector('.site-footer');
    var state={hero:true,offer:false,footer:false};
    function render(){sticky.classList.toggle('is-visible',!state.hero&&!state.offer&&!state.footer);}
    [[hero,'hero'],[offer,'offer'],[footer,'footer']].forEach(function(pair){
      if(!pair[0]) return;
      new IntersectionObserver(function(entries){state[pair[1]]=entries.some(function(entry){return entry.isIntersecting;});render();},{threshold:.08}).observe(pair[0]);
    });
  }
  function initExclusivePlayback(scope){
    if(document.documentElement.dataset.kdktPlaybackReady) return;
    document.documentElement.dataset.kdktPlaybackReady='true';
    document.addEventListener('play',function(event){
      if(!event.target || event.target.tagName!=='VIDEO') return;
      document.querySelectorAll('.'+templateClass+' .kdkt-v1 video').forEach(function(video){if(video!==event.target) video.pause();});
    },true);
  }
  function initPdp(){
    if(document.documentElement.dataset.kdktPdpReady||!document.querySelector('.'+templateClass+' .kdkt-native-buybox .pdp-main-selector')) return;
    if(!window.PDP||typeof window.PDP.init!=='function') return;
    document.documentElement.dataset.kdktPdpReady='true';
    window.PDP.init();
  }
  function init(scope){
    if(!isTechnologyPage()) return;
    initExclusivePlayback(scope);
    initScrollButtons(scope);
    scope.querySelectorAll('[data-kdkt-creators]').forEach(initCreators);
    scope.querySelectorAll('[data-kdkt-product]').forEach(initProduct);
    scope.querySelectorAll('[data-kdkt-sticky]').forEach(initSticky);
    initPdp();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init(document);}); else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();
